import { Link } from 'react-router-dom'
import { Facebook, Linkedin, Twitter, Mail, Phone, MapPin } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-cidh-blue text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About Column */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img 
                src="/logo.png" 
                alt="CIDH Consulting Logo" 
                className="h-20 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Centre International pour le Développement Humain. Nous accompagnons les organisations publiques et privées dans leur croissance depuis 2007.
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-cidh-gold transition-colors"><Facebook size={20} /></a>
              <a href="#" className="hover:text-cidh-gold transition-colors"><Linkedin size={20} /></a>
              <a href="#" className="hover:text-cidh-gold transition-colors"><Twitter size={20} /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-montserrat border-b-2 border-cidh-gold w-fit pb-1">Liens Rapides</h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/a-propos/presentation" className="hover:text-cidh-gold transition-colors">Notre Vision</Link></li>
              <li><Link to="/a-propos/notre-histoire" className="hover:text-cidh-gold transition-colors">Notre Histoire</Link></li>
              <li><Link to="/programmes" className="hover:text-cidh-gold transition-colors">Nos Programmes</Link></li>
              <li><Link to="/projets" className="hover:text-cidh-gold transition-colors">Nos Projets</Link></li>
              <li><Link to="/a-propos/experts" className="hover:text-cidh-gold transition-colors">Experts & Consultants</Link></li>
              <li><Link to="/contact" className="hover:text-cidh-gold transition-colors">Contactez-nous</Link></li>
            </ul>
          </div>

          {/* Services/Categories */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-montserrat border-b-2 border-cidh-gold w-fit pb-1">Services</h4>
            <ul className="flex flex-col gap-3">
              <li><span className="text-gray-300">Formation Professionnelle Continue</span></li>
              <li><span className="text-gray-300">Etudes</span></li>
              <li><span className="text-gray-300">Appui au développement communautaire et rural</span></li>
              <li><span className="text-gray-300">Conseils</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-montserrat border-b-2 border-cidh-gold w-fit pb-1">Contact</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex gap-3 items-start">
                <MapPin className="text-cidh-gold shrink-0" size={20} />
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=Abidjan+II-Plateaux+Las+Palmas+Bld+des+Martyrs+Immeuble+SICOGI+B+Tour+i" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-300 hover:text-cidh-gold transition-colors"
                >
                  Abidjan, II-Plateaux, Las Palmas, Bld des Martyrs – Immeuble SICOGI B, Tour i, 1er étage, porte 101 et 102
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <Phone className="text-cidh-gold shrink-0" size={20} />
                <span className="text-gray-300">Tél. : (+225) 27 22 27 49 09<br/>Cél : (+225) 07 07 58 31 46 / 07 07 48 52 33 / 01 71 59 27 81</span>
              </li>
              <li className="flex gap-3 items-center">
                <Mail className="text-cidh-gold shrink-0" size={20} />
                <span className="text-gray-300">cidhconsulting@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} CIDH Consulting SARL. Tous droits réservés. Créé par l'Excellence.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
